import { apiClient } from "../config";
async function attachSocialAccounts(data: any) {
  const res = await apiClient.post("/admin/attach-social-account", data);
  return res.data;
}

export default attachSocialAccounts;
